import Blockly from 'blockly/browser'
import { defineBlock } from '../Util'

defineBlock(
  'sirenia_api_wait',
  {
    message0: 'wait %1 %2',
    args0: [
      {
        type: 'field_number',
        name: 'DURATION',
        value: 1,
        min: 0
      },
      {
        type: 'field_dropdown',
        name: 'UNIT',
        options: [['seconds', 'seconds'], ['milliseconds', 'milliseconds']]
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Waits for time to pass',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#wait'
  },
  function(block) {
    let numberDuration = block.getFieldValue('DURATION')
    let dropdownUnit = block.getFieldValue('UNIT')
    let commandName = dropdownUnit === 'seconds' ? 'Wait.forSeconds' : 'Wait.forMilliseconds'
    let code = `${commandName}(${numberDuration});\n`
    return code
  }
)

defineBlock(
  'sirenia_api_wait_field',
  {
    message0: 'wait %3 seconds for %1 to %2',
    args0: [
      {
        type: 'input_value',
        name: 'field',
        check: 'Field'
      },
      {
        type: 'field_dropdown',
        name: 'waitType',
        options: [['appear', 'appear'], ['disappear', 'disappear']]
      },
      {
        type: 'field_number',
        name: 'timeoutSeconds',
        value: 1,
        min: 0
      }
    ],
    inputsInline: true,
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Waits a while for a field to appear/disappear',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#wait-for-field'
  },
  function(block) {
    let valueField = Blockly.JavaScript.valueToCode(block, 'field', Blockly.JavaScript.ORDER_ATOMIC)
    let dropdownWaittype = block.getFieldValue('waitType')
    let numberTimeoutseconds = block.getFieldValue('timeoutSeconds')
    let commandName = dropdownWaittype === 'appear' ? 'Wait.forField' : 'Wait.forFieldToDisappear'
    let code = `${commandName}(${valueField || 'null'}, ${numberTimeoutseconds});\n`
    return code
  }
)
